(function () {
  var SAFETY_MS = 1400;

  function revealAll() {
    var left = document.querySelectorAll('.ff-reveal:not(.is-in)');
    Array.prototype.forEach.call(left, function (el) { el.classList.add('is-in'); });
  }

  function init() {
    var els = document.querySelectorAll('.ff-reveal:not(.is-in)');
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    Array.prototype.forEach.call(els, function (el) {
      var r = el.getBoundingClientRect();
      // Anything already on screen (or in a zero-size viewport) shows straight away.
      if (r.top < (window.innerHeight || 0) || r.height === 0) {
        el.classList.add('is-in');
      } else {
        io.observe(el);
      }
    });

    // Fail-safe: never leave content stuck at opacity 0.
    window.setTimeout(revealAll, SAFETY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
